export const SEARCH_FETCH = 'SEARCH_FETCH'
export const SEARCH = 'SEARCH'
export const SEARCH_LOAD_MORE = 'SEARCH_LOAD_MORE'
export const SEARCH_RECENTLY_SEARCHED_DOCS = 'SEARCH_RECENTLY_SEARCHED_DOCS'
